/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */

'use client'

import React, { useEffect } from 'react'
import cheerio from 'cheerio'
import { Tweet } from 'react-tweet'
import { createRoot } from 'react-dom/client'
import { generateId } from '@components/Ackodrive/common/utils'
import styles from './mainContent.module.scss'

// Custom component for rendering a Tweet
const TwitterEmbed = ({ tweetId }) => <Tweet id={tweetId} />

const AckodriveRichTextEditor = ({ content }) => {
  const newEmbeds: any = []

  const getModifiedHtml = htmlContent => {
    if (!htmlContent) return '' // Handle null or undefined htmlContent

    const $: any = cheerio.load(htmlContent, null, false)

    // Set image attributes
    $('img').attr('loading', 'lazy')
    $('img').attr('decoding', 'async')
    $('img').each((_, img) => {
      $(img).attr('width', '740')
      $(img).attr('height', '400')
    })

    // Process divs with raw-html-embed class
    $('div.raw-html-embed').each((index, element) => {
      const twitterEmbed = $(element).find('blockquote.twitter-tweet')
      const redditEmbed = $(element).find('blockquote.reddit-embed-bq')
      const threadsEmbed = $(element).find('blockquote.text-post-media')
      const instagramEmbed = $(element).find('blockquote.instagram-media')

      if (twitterEmbed.length) {
        const tweetUrl = twitterEmbed.find('a').last().attr('href')
        const tweetIdMatch = tweetUrl?.match(/status\/(\d+)/)
        const tweetId = tweetIdMatch ? tweetIdMatch[1] : null

        if (tweetId) {
          newEmbeds.push({
            id: `embed-${index}`,
            type: 'twitter',
            tweetId,
          })
          $(element).replaceWith(`<div class="${styles.htmlBaseContentWrapper}" id="embed-${index}"></div>`)
        }
      } else if (redditEmbed.length || threadsEmbed.length || instagramEmbed.length) {
        const embedContent = $(element).html()

        newEmbeds.push({
          id: `embed-${index}`,
          type: 'reddit-threads-insta',
          htmlContent: embedContent,
        })
        $(element).replaceWith(`<div class="${styles.htmlBaseContentWrapper}" id="embed-${index}"></div>`)
      } else {
        // Handle other social media embeds with iframe (Linkedin, Youtube)
        const content = $(element).html()
        $(element).html(`<div class="${styles.htmlBaseContentWrapper}">${content}</div>`)
      }
    })

    // Process anchor tags to add rel="nofollow noreferrer noopener"
    $('a').each((_, anchor) => {
      const href = $(anchor).attr('href')
      const allowedDomains = ['acko.com', 'ackodrive.com']
      const isAllowedDomain = allowedDomains.some(domain => href?.includes(domain))

      if (!isAllowedDomain) {
        $(anchor).attr('rel', 'nofollow noreferrer noopener')
      } else {
        $(anchor).removeAttr('rel')
      }
    })

    // Add ids to headers
    $('h2, h3').each((_, header) => {
      const text = $(header).text()
      const id = generateId(text)
      $(header).attr('id', id)
    })

    // Process table to match desired format
    $('figure.table').each((_, figure) => {
      const table = $(figure).find('table')
      $(figure).replaceWith(table) // Remove <figure> tag

      table.find('th').each((_, th) => {
        const strong = $(th).find('strong')
        if (strong.length) {
          const p = $('<p></p>').append($('<b></b>').append(strong.contents()))
          $(th).html(p)
        }
      })

      table
        .find('tr')
        .slice(1)
        .find('th')
        .each((_, th) => {
          const td = $('<td></td>').html($(th).html())
          $(th).replaceWith(td)
        })
    })

    // Add two wrapping divs on top of each table
    $('table').each((_, table) => {
      $(table)
        .wrap(`<div class="${styles.tableSubContainer}"></div>`)
        .parent()
        .wrap(`<div class="${styles.tableContainer}"></div>`)
    })

    return $.html()
  }

  const modifiedHtml = getModifiedHtml(content) // Directly generate the modified HTML

  useEffect(() => {
    // After the HTML is rendered, find and render dynamic embeds (Twitter, Reddit, Threads)
    newEmbeds.forEach(({ id, type, tweetId, htmlContent }) => {
      const embedElement = document.getElementById(id)
      if (embedElement) {
        const root = createRoot(embedElement)
        if (type === 'twitter') {
          root.render(<TwitterEmbed tweetId={tweetId} />)
        } else if (type === 'reddit-threads-insta') {
          embedElement.innerHTML = htmlContent

          // Append the relevant external scripts after the HTML is injected
          if (htmlContent?.includes('reddit')) {
            const script = document.createElement('script')
            script.src = 'https://embed.reddit.com/widgets.js'
            script.async = true
            document.body.appendChild(script)
          }

          if (htmlContent.includes('threads')) {
            const script = document.createElement('script')
            script.src = 'https://www.threads.net/embed.js'
            script.async = true
            document.body.appendChild(script)
          }

          if (htmlContent.includes('instagram')) {
            const script = document.createElement('script')
            script.src = 'https://www.instagram.com/embed.js'
            script.async = true
            document.body.appendChild(script)
          }
        }
      }
    })
  }, [newEmbeds])

  return (
    <div
      className={styles.tableContent}
      dangerouslySetInnerHTML={{ __html: modifiedHtml }} // Directly inject the modified HTML
    />
  )
}

export default AckodriveRichTextEditor
